var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.release)?_c('div',{staticClass:"release-details height-all flex align-start gap50"},[_c('ReleaseTabView',{staticClass:"width-all",attrs:{"release":_vm.release,"tabView":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }